import useRequest from '@/websdk/utils/request';

export default (function () {
  const { isRequestSuccessed, data, exec } = useRequest({
    url: `/api/spare`,
    name: 'SPARE_GET',
    method: 'GET',
  });

  return [isRequestSuccessed, data || [], exec];
});
